export default __webpack_public_path__ + "static/media/alongtimeago.42d02166.png";